export default "__VITE_ASSET__a2f4ebae__"